<p>panne-declarer-add works!</p>
